// Phase 7 D6 — Track E T-E3. DatesToolbar.
//
// Toolbar that sits at the top of /dates with one affordance:
//   - Add date (primary) — opens DateDialog (mode='add')
//
// The toolbar is reachable with Tab in declared order; focus rings are
// inherited from the Button primitive's focus tokens.

import { copy } from '@dailydeck/shared/copy';
import { Button } from './ui/Button.js';

export interface DatesToolbarProps {
  onAdd: () => void;
}

export function DatesToolbar({ onAdd }: DatesToolbarProps): JSX.Element {
  return (
    <div
      role="toolbar"
      aria-label={copy.dates.toolbar.toolbarAriaLabel}
      data-testid="dates-toolbar"
      className="flex flex-wrap items-center gap-2"
    >
      <Button
        type="button"
        variant="primary"
        onClick={onAdd}
        aria-label={copy.dates.toolbar.addAriaLabel}
        data-testid="dates-toolbar-add"
      >
        {copy.dates.toolbar.addLabel}
      </Button>
    </div>
  );
}
